import React from "react";

interface ActivateAccountTextProps {
    name: string
}

export default function ActivateAccountText(props: ActivateAccountTextProps) {
    const {name} = props;
    return <div className='mb-7 text-center mw-md mx-auto'>
        <div
            className='mb-0 d-flex align-items-center justify-content-center mx-auto rounded-3'
            style={{width: 100, height: 100}}
        >
            <img
                className='img-fluid'
                style={{height: 100}}
                src='https://produkacja.s3.eu-central-1.amazonaws.com/web/logo/logo-500-500-raw.png'
                alt=''
            />
        </div>
        <h2 className='font-heading mb-4 fs-7 text-white'>
            Dokończ tworzenie konta
        </h2>
        <p className='mb-0 fs-9 fw-medium text-secondary-light'>
            Witaj {name}! Już tylko jeden krok dzieli Cię od rozpoczęcia wspaniałej przygody.
        </p>
    </div>
}